import { render, staticRenderFns } from "./canteenOrder.vue?vue&type=template&id=408761b6&scoped=true"
import script from "./canteenOrder.vue?vue&type=script&lang=js"
export * from "./canteenOrder.vue?vue&type=script&lang=js"
import style0 from "./canteenOrder.vue?vue&type=style&index=0&id=408761b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408761b6",
  null
  
)

export default component.exports